import { Button } from '@/components/base/button'
import { Dialog, DialogActions, DialogBody, DialogTitle, ShowProps } from '@/components/base/dialog'
import { Divider } from '@/components/base/divider'
import { Text } from '@/components/base/text'
import { useEffect, useState } from 'react'
import { NotificationQuery } from './__generated__/show_query'
import { NotificationQuery as Query } from './show_query'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'
import { format } from 'date-fns'
import { Mutation as EditMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { UpdateNotificationMutation } from './__generated__/update_mutation'
import { NotificationAttributes } from '@/types'

type Notification = NotificationQuery['notifications']['nodes'][0]

export const ShowDialog = ({ id, open, setOpen }: ShowProps) => {
  const [notification, setNotification] = useState<Notification | null>(null)
  const { data, loading, error } = useQuery<NotificationQuery>(
    Query,
    { variables: { filters: { idEq: id } } }
  )

  const {
    attributes,
    setAttributes,
    save
  } = useForm<UpdateNotificationMutation, NotificationAttributes, NotificationQuery, Notification>({
    id: id || '',
    defaultValues: {
      readAt: undefined
    },
    mutation: EditMutation,
    resultKey: 'updateNotification'
  })

  useEffect(() => {
    if (!data || !id) return

    setNotification(data.notifications.nodes[0])
  }, [id, data])

  const saveInAMo = () => { setTimeout(save, 1000) }

  const onRead = () => {
    setAttributes({ ...attributes, readAt: ((new Date)).toISOString() })
    saveInAMo()
  }

  return (
    <>
      <Dialog open={open} size="7xl" onClose={setOpen}>
        <DialogTitle>
          {
            loading || !notification
              ? <Loading />
              : <div className="flex flex-row justify-between">
                <div>
                  <span className="flex flex-row gap-4 items-center pb-6">
                    { notification.title }
                  </span>
                </div>
              </div>
          }
        </DialogTitle>
        <DialogBody>
          { error && <Error message={error.message} />}
          { notification && <div className="flex flex-col gap-4">
            <Text className="whitespace-pre-wrap">{ notification.message }</Text>
            <Divider />
            <Text className="text-zinc-500">{ format(notification.postedAt, 'KK:mm dd/MM/yyyy') }</Text>
          </div> }
        </DialogBody>
        <DialogActions>
          {
            notification &&
              !notification.readAt &&
              <span><Button color="green" onClick={onRead}>Mark as read</Button></span>
          }
          {
            notification &&
              notification.readAt &&
              <span><Button color="green" onClick={onRead}>Mark as unread</Button></span>
          }
        </DialogActions>
      </Dialog>
    </>
  )
}
